'use client';
import React, { useContext } from 'react';

import DataContext from '@/contexts/DataContext';
import { useSettings } from '@/hooks/use-settings';
import { useComponentLogger } from '@/lib/component-logger';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { Dropdown } from '@/components/core/dropdown/dropdown';
import { DropdownTrigger } from '@/components/core/dropdown/dropdown-trigger';
import { DropdownPopover } from '@/components/core/dropdown/dropdown-popover';
import { GroupedListExpandable } from '@/components/widgets/grouped-lists/grouped-list-expandable';
import { DetailCard } from '@/components/widgets/detail-lists/detail-card';
import { config } from '@/config';

// const metadata = { title: `${config?.site?.name}` };

export function HomePage() {
  const logger = useComponentLogger("HomePage")
  const { currentProject, appsAndViews } = useContext(DataContext);
  const settings = useSettings();

  logger.debug("proj change", currentProject)

  return (
    <Box
    sx={{
        maxWidth: 'var(--Content-maxWidth)',
        m: 'var(--Content-margin)',
        p: 'var(--Content-padding)',
        width: 'var(--Content-width)',
    }}
    >
    <Stack spacing={4}>
    {/* <Stack direction={{ xs: 'column', sm: 'row' }} spacing={3} sx={{ alignItems: 'flex-start' }}> */}
      <Box sx={{ flex: '1 1 auto' }}>
          <Typography variant="h4">Apps</Typography>
      </Box>
      
      {currentProject?.id !== null ? 
        <Stack spacing={0.5}>
        <DetailCard config={{icon: 'bell', name: 'Alerts', href:`/alerts?proj=${currentProject?.id}` ?? null}} />
        <DetailCard config={{icon: 'hourglass', name: 'Historian', href:`/historian?proj=${currentProject?.id}` ?? null}} />
        <GroupedListExpandable items={appsAndViews}/>
        </Stack>
      : <Typography variant='subtitle1' sx={{ color: "var(--mui-palette-grey-500)", fontStyle: "italic"  }} >Please select a project</Typography>
      }
      
    </Stack>
    </Box>
  );
}
